(function () {
    function isRailsUJSLoaded() {
        return window.Rails ||
            window.jQuery?.rails;
    }
    function swapAttr(element, dataAttr, upAttr) {
        if (element.hasAttribute(dataAttr)) {
            let dataValue = element.getAttribute(dataAttr);
            up.element.setMissingAttr(element, upAttr, dataValue);
            element.removeAttribute(dataAttr);
        }
    }
    function defineMacro(elementSelector, relevantFn) {
        up.macro(`:is([data-confirm], [data-method]):is(${elementSelector})`, function (element) {
            if (isRailsUJSLoaded() && relevantFn(element)) {
                swapAttr(element, 'data-confirm', 'up-confirm');
                swapAttr(element, 'data-method', 'up-method');
            }
        });
    }
    defineMacro('a[href], [up-href]', (el) => up.link.isFollowable(el));
    defineMacro('form, input[type=submit], button[type=submit], button:not([type])', (el) => up.form.isSubmittable(up.form.get(el)));
})();
